import { navigate } from '@reach/router';

export const redirect = (route) => {
    navigate(route);
};

export const back = () => {
    window.history.back();
};
